import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/legal/";

const CareOfDependentsLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionTips = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column width={4} container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Message className={styles.highlightsItemWhiteBG} info>
                  <Header.Subheader className={styles.highlightsItemSubHeader} >
                    <p className={styles.highlightsItemHeaderQuestion}><br/>Hiring a human service professional can also 
                    help educate the entire family on creating a plan for the future. <br/><br/> </p>
                  </Header.Subheader>
              </Message>
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                <Header as='h2' icon className={styles.highlightsItemHeader} >          
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} > <br/>In addition to setting up a Special Needs Trust, there 
                        are a few other things that can be done to plan for the care of the older adult's dependents. Setting 
                        up a care plan before the older adult gets sick or starts to decline is incredibly important. Including 
                        family members (specifically siblings of the disabled adult child) in this planning is essential in making 
                        sure that more than just the older adult is aware of the specific care needs of the disabled person.  
                        <br/><br/>
                        Some older caregivers are reluctant to burden their other children or other family members with this, but 
                        new caregivers face a steep learning curve to understand the disabled adult’s needs after the older adult 
                        is unable to communicate or has passed away. Having this information in writing can ensure care is not 
                        interrupted during this time. 
                        <br/><br/>
                    </p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tips on Planning for Care of Adult Children/Family Members with Special Needs </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}CareOfDependentsLearnMore1.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(CareOfDependentsLearnMore);
